import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import { DEFAULT_SALARIES_CONFIG, normalizeSalariesConfig, buildSalariesEntityPrefixes } from './salariesConfigDefaults';

let hydratePromise = null;

function hydrateSalariesConfig(patchSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/salaries/config')
      .then((response) => {
        const raw = response?.data !== undefined ? response.data : response;
        const normalized = normalizeSalariesConfig(raw || {});
        syncSalariesConfigToSettings(normalized, patchSettings);
        return normalized;
      })
      .catch(() => {
        hydratePromise = null;
        return DEFAULT_SALARIES_CONFIG;
      });
  }
  return hydratePromise;
}

/** Live salaries module config — synced from API once, then from SettingsContext. */
export function useSalairesConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (settings?.salaries && Object.keys(settings.salaries).length > 0) return;
    void hydrateSalariesConfig(patchSettings);
  }, [settings?.salaries, patchSettings]);

  return useMemo(
    () => normalizeSalariesConfig(settings?.salaries || {}),
    [settings?.salaries],
  );
}

export function syncSalariesConfigToSettings(config, patchSettings, existingSettings = {}) {
  const normalized = normalizeSalariesConfig(config);
  patchSettings({
    salaries: normalized,
    configuration: {
      entityPrefixes: {
        ...(existingSettings?.configuration?.entityPrefixes || {}),
        ...buildSalariesEntityPrefixes(normalized),
      },
    },
  }, { persist: false });
  return normalized;
}
